<div class="alert alert-danger" *ngIf="data?.is_suspended == 1" role="alert"><strong>Account suspended.</strong> Account changes are unavailable. Review the suspension in Risk Review.</div>
<fieldset class="border-0 p-0 m-0 w-100" [disabled]="data?.is_suspended == 1" [attr.inert]="data?.is_suspended == 1 ? '' : null">
<form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
    <div class="row">
        <div class="col-12" [ngClass]="{'col-md-6': !fullwidth}">
            <div class="page-section">
                <div class="page-section-header">
                    <h2 class="page-section-title">Player Form</h2>
                    <div class="page-section-actions">
                        <button type="button" class="btn btn-sm btn-outline-light" (click)="close()" *ngIf="fullwidth">Cancel</button>
                    </div>
                </div>
                <div class="page-section-form">

                    <!-- ─── Basic Info ─── -->
                    <div class="form-group-box">
                        <div class="form-group-title">Basic Info</div>
                        <div class="form-group-body">
                            <div class="row">
                                <div class="col-4 col-md-4">
                                    <div class="mb-3">
                                        <label for="code" class="form-label">Code</label>
                                        <input type="text" class="form-control form-control-sm" id="code" name="code" #code="ngModel"
                                            [(ngModel)]="data.code">
                                    </div>
                                </div>
                                <div class="col-8 col-md-8">
                                    <div class="mb-3">
                                        <label for="name" class="form-label">Name <em>*</em></label>
                                        <input type="text" class="form-control form-control-sm" id="name" name="name" #name="ngModel"
                                            [(ngModel)]="data.name" required>
                                        <div *ngIf="f.submitted && name.invalid" class="invalid-feedback">
                                            <div *ngIf="name.errors.required">Name is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="fullname" class="form-label">Fullname</label>
                                <input type="text" class="form-control form-control-sm" id="fullname" name="fullname"
                                    #fullname="ngModel" [(ngModel)]="data.fullname">
                            </div>
                            <div class="row">
                                <div class="col-5 col-md-4">
                                    <div class="mb-3">
                                        <label for="dob" class="form-label">DOB</label>
                                        <input type="date" class="form-control form-control-sm" id="dob" name="dob" #dob="ngModel"
                                            [(ngModel)]="data.dob">
                                    </div>
                                </div>
                                <div class="col-7 col-md-8">
                                    <div class="mb-3">
                                        <label for="mobile" class="form-label">Mobile <em>*</em></label>
                                        <input type="text" class="form-control form-control-sm" id="mobile" name="mobile" #mobile="ngModel"
                                            [(ngModel)]="data.mobile" required>
                                        <div *ngIf="f.submitted && mobile.invalid" class="invalid-feedback">
                                            <div *ngIf="mobile.errors.required">Mobile is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ─── Bank Accounts ─── -->
                    <div class="form-group-box">
                        <div class="form-group-title">
                            Bank Accounts
                            <button type="button" class="btn btn-outline-primary ms-auto" style="font-size: 10px; padding: 2px 8px;" (click)="addBank()">+ Add</button>
                        </div>
                        <div class="form-group-body">
                            <div class="bank-row" *ngFor="let m of data.banks; let i = index">
                                <div class="bank-row-fields">
                                    <div class="flex-fill">
                                        <label class="form-label">Bank Name</label>
                                        <input type="text" class="form-control form-control-sm" [id]="'payment_bank_' + i"
                                            [name]="'payment_bank_' + i" [(ngModel)]="m.bank" placeholder="e.g. Maybank">
                                        <div *ngIf="f.submitted && m.account && m.account.length > 0 && !m.bank"
                                            class="invalid-feedback">Bank is required</div>
                                        <div *ngIf="f.submitted && m.bank && m.bank.length <= 2" class="invalid-feedback">
                                            Bank name too short</div>
                                    </div>
                                    <div class="flex-fill">
                                        <label class="form-label">Account No.</label>
                                        <input type="text" class="form-control form-control-sm" [id]="'payment_acccount_' + i"
                                            [name]="'payment_acccount_' + i" [(ngModel)]="m.account" placeholder="e.g. 1234567890">
                                        <div *ngIf="f.submitted && m.bank && m.bank.length > 0 && !m.account"
                                            class="invalid-feedback">Account number is required</div>
                                        <div *ngIf="f.submitted && m.account && m.account.length <= 2" class="invalid-feedback">
                                            Account number too short</div>
                                    </div>
                                    <button type="button" class="btn btn-sm btn-outline-danger bank-row-remove" (click)="removeBank(i)"
                                        title="Remove">&times;</button>
                                </div>
                            </div>
                            <div *ngIf="!data.banks || data.banks.length === 0" class="text-muted" style="font-size: 12px; font-style: italic;">
                                No bank accounts added yet.
                            </div>
                        </div>
                    </div>

                    <!-- ─── Account Settings ─── -->
                    <div class="form-group-box" *ngIf="data.uuid && stagingReady">
                        <div class="form-group-title">Staging access</div>
                        <div class="form-group-body">
                            <label class="form-check">
                                <input type="checkbox" class="form-check-input" name="stagingEnabled"
                                    [(ngModel)]="staging.enabled" [disabled]="stagingSaving">
                                <span class="form-check-label">Allow staging access</span>
                            </label>
                            <p>Test balance: {{ staging.balance }}. Test funds cannot be withdrawn or transferred to the real balance.</p>
                            <button type="button" class="btn btn-sm btn-outline-primary" (click)="saveStaging()" [disabled]="stagingSaving">Save staging access</button>
                            <p role="status" *ngIf="stagingMessage">{{ stagingMessage }}</p>
                        </div>
                    </div>
                    <div class="form-group-box">
                        <div class="form-group-title">Account Settings</div>
                        <div class="form-group-body">
                            <div class="row">
                                <div class="col-6 col-md-3">
                                    <div class="mb-3">
                                        <label for="status" class="form-label">Status <em>*</em></label>
                                        <select class="form-select form-select-sm" name="status" #status="ngModel" [(ngModel)]="data.status"
                                            required>
                                            <option [value]="1">Active</option>
                                            <option [value]="0">Disabled</option>
                                        </select>
                                        <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                                            <div *ngIf="status.errors.required">Status is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 col-md-3">
                                    <div class="mb-3">
                                        <label for="can_login" class="form-label">Can Login <em>*</em></label>
                                        <select class="form-select form-select-sm" name="can_login" #can_login="ngModel"
                                            [(ngModel)]="data.can_login" required>
                                            <option [value]="0">No</option>
                                            <option [value]="1">Yes</option>
                                        </select>
                                        <div *ngIf="f.submitted && can_login.invalid" class="invalid-feedback">
                                            <div *ngIf="can_login.errors.required">Can Login is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6" *ngIf="data.can_login == 1">
                                    <div class="mb-3">
                                        <label for="password" class="form-label">Password <em>*</em></label>
                                        <input type="password" class="form-control form-control-sm" name="password" #password="ngModel"
                                            [(ngModel)]="data.password" required />
                                        <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                                            <div *ngIf="password.errors.required">Password is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ─── Rates & Commission ─── -->
                    <div class="form-group-box">
                        <div class="form-group-title">Rates &amp; Commission</div>
                        <div class="form-group-body">
                            <div class="mb-3">
                                <label for="referral_code" class="form-label">Referral Username</label>
                                <input type="text" class="form-control form-control-sm" id="referral_code" name="referral_code"
                                    [(ngModel)]="data.referral_code">
                            </div>
                            <div class="row">
                                <div class="col-4 col-md-4" *ngIf="data.referral_code">
                                    <div class="mb-3">
                                        <label for="referral_rate" class="form-label">Referral Rate</label>
                                        <input type="text" class="form-control form-control-sm" id="referral_rate" name="referral_rate"
                                            [(ngModel)]="data.referral_rate" [disabled]="!permission.can_manage">
                                    </div>
                                </div>
                                <div class="col-6 col-md-4">
                                    <div class="mb-3">
                                        <label for="point_rate" class="form-label">Point Rate</label>
                                        <input type="text" class="form-control form-control-sm" id="point_rate" name="point_rate"
                                            [(ngModel)]="data.point_rate" [disabled]="!permission.can_manage">
                                    </div>
                                </div>
                                <div class="col-6 col-md-4">
                                    <div class="mb-3">
                                        <label for="rebate_rate" class="form-label">Rebate Rate</label>
                                        <input type="text" class="form-control form-control-sm" id="rebate_rate" name="rebate_rate"
                                            [(ngModel)]="data.rebate_rate" [disabled]="!permission.can_manage">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3" *ngIf="data.uuid">
                                <div class="col-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" name="exclude_referral_commission" id="exclude_referral_commission" 
                                            [(ngModel)]="data.exclude_referral_commission" [disabled]="!new_permission['edit-referral-rate']">
                                        <label class="form-check-label" for="exclude_referral_commission">
                                            Exclude from Referral Commission (Auto Rule)
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 col-md-4">
                                    <div class="mb-3">
                                        <label for="is_agent" class="form-label">Is Agent <em>*</em></label>
                                        <select class="form-select form-select-sm" name="is_agent" #is_agent="ngModel"
                                            [(ngModel)]="data.is_agent" required>
                                            <option [value]="0">No</option>
                                            <option [value]="1">Yes</option>
                                        </select>
                                        <div *ngIf="f.submitted && is_agent.invalid" class="invalid-feedback">
                                            <div *ngIf="is_agent.errors.required">Is Agent is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 col-md-4" *ngIf="data.is_agent == 1">
                                    <div class="mb-3">
                                        <label for="agent_rate" class="form-label">Agent Rate <em>*</em></label>
                                        <ng-select id="agent_rate" name="agent_rate" [(ngModel)]="data.agent_rate"
                                            [readonly]="!new_permission['edit-referral-rate'] && (data.referral_is_agent || data.uuid)">
                                            <ng-option *ngFor="let option of agentRateOptions" [value]="option.value">{{ option.label }}</ng-option>
                                        </ng-select>
                                        <small class="text-muted" *ngIf="!redShareMode">Example: 0.60 means 0.60%, so 100.00 x 0.60% = 0.60.</small>
                                        <small class="text-muted" *ngIf="redShareMode">Red Share Mode: enter a whole-number percentage (e.g. 50 = 50%). Each upline automatically earns the rate spread over its downline (e.g. L1 at 50% earns 5% over L2 at 45%). Cannot exceed the parent agent's rate.</small>
                                        <small class="text-muted" *ngIf="data.referral_is_agent">Set by parent agent</small>
                                    </div>
                                </div>

                                <!-- Admin override rate: the master "overriding rate" that beats the
                                     member level and the base agent rate. Used to make a root/master
                                     agent override the whole company's commission (bypasses the level cap). -->
                                <div class="col-6 col-md-4" *ngIf="data.is_agent == 1 && data.uuid">
                                    <div class="mb-3">
                                        <label for="agent_rate_override" class="form-label">Override Rate (%)</label>
                                        <input type="number" class="form-control form-control-sm"
                                            id="agent_rate_override" name="agent_rate_override"
                                            [(ngModel)]="data.agent_rate_override"
                                            min="0" max="100" step="0.01" placeholder="Leave blank to use level rate">
                                        <small class="text-muted">Admin override — takes priority over the member level and the base Agent Rate, and bypasses the level cap. This is how a master/root agent overrides the whole company's commission. Leave blank to fall back to the level rate.</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ─── Player Level ─── -->
                    <div class="form-group-box" *ngIf="data.uuid">
                        <div class="form-group-title">Player Level</div>
                        <div class="form-group-body">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="mb-3">
                                        <label for="player_level" class="form-label">Level</label>
                                        <select class="form-select form-select-sm" name="player_level" [(ngModel)]="data.player_level">
                                            <option [ngValue]="null">— None —</option>
                                            <option *ngFor="let lvl of player_levels" [ngValue]="lvl.id">{{ lvl.title }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="level_log && level_log.length > 0">
                                <div class="form-group-title" style="font-size:12px; margin-bottom:6px;">Change History</div>
                                <table class="table table-sm table-bordered" style="font-size:12px;">
                                    <thead><tr><th>From</th><th>To</th><th>Type</th><th>By</th><th>Date</th></tr></thead>
                                    <tbody>
                                        <tr *ngFor="let log of level_log">
                                            <td>{{ log.from_level_title || '—' }}</td>
                                            <td>{{ log.to_level_title || '—' }}</td>
                                            <td>{{ log.change_type }}</td>
                                            <td>{{ log.changed_by_name || '—' }}</td>
                                            <td>{{ log.create_on | date:'yyyy-MM-dd HH:mm' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <!-- ─── Remark ─── -->
                    <div class="form-group-box">
                        <div class="form-group-title">Remark</div>
                        <div class="form-group-body">
                            <textarea rows="3" class="form-control form-control-sm w-100" name="remark" #remark="ngModel"
                                [(ngModel)]="data.remark" placeholder="Optional notes about this player..."></textarea>
                        </div>
                    </div>

                    <!-- ─── Submit ─── -->
                    <button type="submit" class="btn btn-primary btn-sm w-100">Update Player</button>
                </div>
            </div>
        </div>
    </div>
</form>

</fieldset>
